import {
  useState,
  Fragment,
  useContext,
  useEffect,
  useRef,
} from "react";
import { useNavigate } from "react-router-dom";
import { canalOtp, trackEvent, trackFormErrors } from "../../services/analytics/track";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import * as Sentry from "@sentry/react";
import { RecaptchaView } from "../../components/captcha/recaptcha";
import { SuccessAlert } from "../../components/alerts/successAlert";
import { ErrorAlert } from "../../components/alerts/errorAlert";
import { AuthContext } from "../../context/Auth/AuthContext";
import { CreditUserContext } from "../../context/CreditUser/CreditUserContext";
import { validarEspaciosEnBlanco, normalizeEmail } from "../../utils/validacionesForms";
import { VisitorService } from "../../services/visitors/visitor.service";
import { normalizePhoneNumber, toIsoWithOffset } from "./utils";
import { useCreditDraftStore } from "../../store/creditDraftStore";
import { runValidateFieldsSignUp } from "./utils/validationForm";
import { Login } from "../../components/backgrounds/Login";
import { useMobileDetection } from "../../hooks/use-mobile-detection";
import FilterableSelect from "../../components/new_components/FilterableSelect";
import StepInput from "../../components/new_components/StepInput";
import { NextButton } from "../../components/new_components/buttonsFlow";
import { ChevronLeft } from "lucide-react";
import { variablesGlobales } from "../../configs/variables";
import { getStoredUtmReferral } from "../../services/utmleads/utmReferral";
import { useUtmTracking } from "../../hooks/useUtmTracking";

export function SignupPage() {
  useUtmTracking();
  const { draft, loadDraft } = useCreditDraftStore();
  const { updateMail, updatePhone } = useContext(AuthContext);
  const { executeRecaptcha } = useGoogleReCaptcha();
  const { updateCreditUser } = useContext(CreditUserContext);
  const { isDesktop, screenWidth, screenHeight } = useMobileDetection();
  const formRef = useRef(null);
  const [, setTimer] = useState(0);
  const navigate = useNavigate();

  const [messsageAlert, setMessageAlert] = useState("");
  const [isOpenSuccess, setIsOpenSuccess] = useState(false);
  const [isOpenError, setIsOpenError] = useState(false);
  const [viewalert, setViewalert] = useState(false);
  const [errors, setErrors] = useState({});
  const [formSignup, setFormSignup] = useState({
    typeDocument: "",
    document: "",
    email: "",
    phone: "",
    terms: false,
    policyData: false,
    fuente: localStorage.getItem("utm_id") ?? "Galilea",
  });
  const [channelOtp] = useState({ channel: "W" });
  const [isLoading, setIsLoading] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [submitError, setSubmitError] = useState("");

  const [isOpenChannels, setIsOpenChannels] = useState(false);
  const [policyAccessories, setPolicyAccessories] = useState(false);
  const [channelsContact, setChannelsContact] = useState(false);
  const [selectedChannels, setSelectedChannels] = useState([]);
  const [typeDocumentList] = useState([
    {
      value: 1,
      label: "Cédula de ciudadanía",
    },
    {
      value: 2,
      label: "Cédula de extranjería",
    },
  ]);

  const channels = [
    { id: "sms", label: "SMS" },
    { id: "calls", label: "Llamada" },
    { id: "email", label: "Correo Electrónico" },
    { id: "whatsapp", label: "WhatsApp" },
    { id: "push", label: "Notificaciones Push" },
  ];

  const handleCheckboxChange = (channelId) => {
    const newSelectedChannels = selectedChannels.includes(channelId)
      ? selectedChannels.filter((id) => id !== channelId)
      : [...selectedChannels, channelId];

    setSelectedChannels(newSelectedChannels);
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    let isError;
    if (name === "phone") {
      setErrors((prev) => ({ ...prev, [name]: "" }));
      const { normalized, valid } = normalizePhoneNumber(value);
      setFormSignup((prev) => ({ ...prev, [name]: normalized }));
      setErrors((prev) => ({
        ...prev,
        [name]: valid ? "" : "Ingresa un número válido de 10 dígitos",
      }));
      return;
    }
    if (name === "email") {
      let cleanedEmail = normalizeEmail(value);
      isError = validarEspaciosEnBlanco(name, cleanedEmail);
      if (isError[0]) {
        setErrors((prev) => ({
          ...prev,
          [name]: "El correo no debe contener espacios en blanco.",
        }));
      } else if (cleanedEmail !== value) {
        setErrors((prev) => ({
          ...prev,
          [name]: "El correo contiene caracteres inválidos que fueron removidos.",
        }));
      } else {
        setErrors((prev) => ({ ...prev, [name]: "" }));
      }
      setFormSignup((prev) => ({ ...prev, [name]: cleanedEmail }));
      return;
    }
    if (name === "acceptAll") {
      setErrors((prev) => ({ ...prev, terms: "" }));
      setErrors((prev) => ({ ...prev, policyData: "" }));
      setFormSignup({
        ...formSignup,
        terms: checked,
        policyData: checked,
      });
      setPolicyAccessories(checked);
      setChannelsContact(checked);
      setSelectedChannels(
        checked ? ["sms", "email", "whatsapp", "calls", "push"] : [],
      );
    } else {
      if (type === "checkbox") {
        if (name === "policyAccessories") {
          setPolicyAccessories(checked);
        } else if (name === "channelsContact") {
          setChannelsContact(checked);
          setSelectedChannels(
            checked ? ["sms", "email", "whatsapp", "calls", "push"] : [],
          );
        } else {
          setErrors((prev) => ({ ...prev, [name]: "" }));
          setFormSignup({ ...formSignup, [name]: checked });
        }
        return;
      }
      setErrors((prev) => ({ ...prev, [name]: "" }));
      setFormSignup({ ...formSignup, [name]: value });
    }
  };

  const handleChangeSelect = (e) => {
    const { name, value } = e.target;
    if (name === "typeDocument") setErrors((prev) => ({ ...prev, [name]: "" }));
    setFormSignup({ ...formSignup, [name]: value });
  };

  const handleOpenAlert = (type, message, isOpenChannels, miliseconds) => {
    if (type === "success") {
      setMessageAlert(message);
      setIsOpenSuccess(isOpenChannels);
      setViewalert(true);
      setTimeout(() => {
        setMessageAlert("");
        setIsOpenSuccess(false);
        setViewalert(false);
      }, 10000);
    }
    if (type === "error") {
      setMessageAlert(message);
      setIsOpenError(isOpenChannels);
      setViewalert(true);
      setTimeout(() => {
        setMessageAlert("");
        setIsOpenError(false);
        setViewalert(false);
      }, miliseconds ?? 10000);
    }
  };

  const handleClearStateAlert = () => {
    setViewalert(false);
    setMessageAlert("");
    setIsOpenSuccess(false);
    setIsOpenError(false);
  };

  const getSubmitErrorMessage = (isNetworkError) =>
    isNetworkError
      ? "Revisa tu conexión e intenta de nuevo"
      : "Tuvimos un problema, intenta de nuevo en unos minutos";

  // Token de reCAPTCHA v3: un reintento si no cargó; si falla no bloquea el registro
  const getRecaptchaToken = async () => {
    for (let attempt = 0; attempt < 2; attempt++) {
      try {
        if (executeRecaptcha) {
          const token = await executeRecaptcha("signup");
          if (token) return token;
        }
      } catch (captchaError) {
        // se reintenta una vez
      }
      if (attempt === 0) await new Promise((resolve) => setTimeout(resolve, 1000));
    }
    try {
      Sentry.captureMessage("reCAPTCHA no disponible en el registro", {
        level: "warning",
        tags: { flow: "signup", recaptcha: "sin_token" },
      });
    } catch (sentryError) {
      // no debe afectar el registro
    }
    return null;
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      if (isDisabled || isLoading) return;
      handleSubmit(e);
    }
  };

  const handleSubmit = async (event) => {
    setIsLoading(true);
    setIsDisabled(true);
    setSubmitError("");
    event.preventDefault();

    try {
      let copyCreditInfo = { ...draft };
      handleClearStateAlert();

      // if (timer <= variablesGlobales.timemaxSignupForm) {
      //   return navigate("/");
      // }

      const setErrorsAndTrack = (newErrors) => {
        setErrors(newErrors);
        trackFormErrors("registro", newErrors, formSignup);
      };
      if (!runValidateFieldsSignUp(formSignup, setErrorsAndTrack)) {
        setIsLoading(false);
        setIsDisabled(false);
        return;
      }

      const recaptchaToken = await getRecaptchaToken();

      copyCreditInfo.documento = formSignup.document;
      copyCreditInfo.tasaInteresCorriente = localStorage.getItem(
        "currentInterestRate",
      );
      copyCreditInfo.status = "Solicitado";

      updateCreditUser(copyCreditInfo);

      const requiredChannels = ["email", "whatsapp"];
      const channelsContacted = [...selectedChannels];
      requiredChannels.forEach((ch) => {
        if (!channelsContacted.includes(ch)) channelsContacted.push(ch);
      });

      const updatedFormSignup = {
        ...formSignup,
        ancillaryPurposes: {
          authorizes: policyAccessories,
          dateAuthorize: policyAccessories ? toIsoWithOffset(new Date()) : null,
        },
        authorizesToBeContacted: {
          // authorizes y dateAuthorize se mantienen basados en lo selecionado por el usuario
          authorizes: selectedChannels.length > 0,
          dateAuthorize:
            selectedChannels.length > 0 ? toIsoWithOffset(new Date()) : null,
          channels: channelsContacted,
          channelsContacted: selectedChannels,
        },
      };
      let payload = Object.assign(
        {},
        {
          user: {
            ...updatedFormSignup,
            lastPartnerReferral: getStoredUtmReferral(),
          },
          creditInfo: copyCreditInfo,
          channelOtp: channelOtp.channel,
          ...(recaptchaToken ? { recaptchaToken } : {}),
        },
      );

      const hasClientResponse = await VisitorService.hasClient(
        formSignup.document,
        formSignup.email,
        formSignup.phone,
        recaptchaToken,
      );
      if (hasClientResponse.error) {
        setSubmitError(getSubmitErrorMessage(hasClientResponse.isNetworkError));
        return;
      }
      const { message } = hasClientResponse;
      handleClearStateAlert();
      if (message?.hasUser) {
        trackEvent("registro_rechazado", { motivo: "ya_registrado" });
        setIsLoading(false);
        setIsDisabled(false);
        handleOpenAlert(
          "error",
          `El número de documento ya tiene una cuenta en Galilea, te invitamos a ingresar`,
          true,
        );
        setTimeout(() => {
          return navigate("/ingresar");
        }, 3000);
      } else if (
        message?.hasUserEmail === true ||
        message?.hasUserPhone === true
      ) {
        trackEvent("registro_rechazado", { motivo: "contacto_en_uso" });
        setIsLoading(false);
        setIsDisabled(false);
        handleOpenAlert(
          "error",
          `El número de teléfono o correo electrónico están asociados a otra cuenta de Galilea`,
          true,
        );
        return;
      } else {
        const responseService = await VisitorService.createVisitor(payload);
        if (responseService.error) {
          trackEvent("registro_rechazado", { motivo: "error" });
          if (
            responseService.message.details === "INVALID_TERM" ||
            responseService.message.details === "INVALID_REQUESTED_AMOUNT"
          ) {
            setIsLoading(false);
            setIsDisabled(false);
            handleOpenAlert(
              "error",
              "Por favor recargue su navegador antes de solicitar nuevamente el crédito",
              true,
            );
            setTimeout(() => {
              navigate("/");
            }, 5000);
            return;
          }
          if (responseService.message?.code === "DOMAIN") {
            setIsLoading(false);
            setIsDisabled(false);
            handleOpenAlert(
              "error",
              `${responseService.message?.message}`,
              true,
            );
            setTimeout(() => {
              handleClearStateAlert();
              return;
            }, 5000);
          } else if (
            typeof responseService.message?.message === "string" &&
            responseService.message?.message.includes("El número de telefono")
          ) {
            setIsLoading(false);
            setIsDisabled(false);
            handleOpenAlert(
              "error",
              `${responseService.message?.message}`,
              true,
            );
            setTimeout(() => {
              handleClearStateAlert();
            }, 5000);
          } else if (
            typeof responseService.message?.message === "string" &&
            responseService.message?.message.includes("El campo Tipo de documento no es válido.")
          ) {
            setIsLoading(false);
            setIsDisabled(false);
            handleOpenAlert(
              "error",
              responseService.message.message,
              responseService.message.error,
            );
            setTimeout(() => {
              handleClearStateAlert();
              return navigate("/");
            }, 5000);
          } else if (
            responseService.isNetworkError ||
            typeof responseService.message?.message !== "string" ||
            responseService.message?.statusCode >= 500
          ) {
            // Falla de red o del servidor: se conserva el formulario y se permite reintentar
            setSubmitError(getSubmitErrorMessage(responseService.isNetworkError));
          } else {
            setIsLoading(false);
            setIsDisabled(false);
            handleOpenAlert(
              "error",
              responseService.message.message,
              responseService.message.error ?? true,
            );
            setTimeout(() => {
              handleClearStateAlert();
              return navigate("/");
            }, 5000);

          }
        } else {
          trackEvent("registro_completado", { canal_otp: canalOtp(channelOtp.channel) });
          updateMail(formSignup.email);
          updatePhone(formSignup.phone);
          let credit_id = responseService.message?.credit_id;
          localStorage.setItem("doc", formSignup.document);
          localStorage.setItem("is_signin", true);
          localStorage.setItem("phone", formSignup.phone);
          localStorage.setItem("credit_id", credit_id);
          localStorage.setItem("email", formSignup.email);
          return navigate("/validate-phone", {
            state: {
              email: localStorage.getItem("phone"),
              doc: formSignup.document,
            },
          });
        }
      }
    } catch (error) {
      console.log(error);
      return handleOpenAlert(
        "error",
        "Ups! ocurrido un error al conectarse con el servidor, por favor intenta nuevamente!",
        true,
      );
    } finally {
      setIsLoading(false);
      setIsDisabled(false);
    }
  };

  const getFormMarginTop = () => {
    if (screenHeight <= 199) return "460px";
    if (screenHeight <= 299) return "420px";
    if (screenHeight <= 399) return "380px";
    if (screenHeight <= 499) return "340px";
    if (screenHeight <= 515) return "300px";
    if (screenHeight <= 565) return "260px";
    if (screenHeight <= 599) return "220px";
    if (screenHeight <= 655) return "180px";
    if (screenHeight <= 699) return "140px";
    if (screenHeight <= 750) return "100px";
    if (screenHeight >= 751) return "10px";
  };

  const getFormHeight = () => {
    if (screenWidth <= 1200) return "600px";
    if (screenWidth <= 1360) return "650px";
    if (screenWidth <= 1536) return "700px";
    if (screenWidth > 1536) return "830px";
    return "820px";
  };
  const getFormGap = () => {
    if (screenWidth <= 1200) return "15px";
    if (screenWidth <= 1360) return "10px";
    if (screenWidth <= 1536) return "10px";
    if (screenWidth > 1536) return "15px";
    return "15px";
  };

  useEffect(() => {
    const isSignin = localStorage.getItem("is_signin");
    const tokenSession = localStorage.getItem("token_jwt");

    if (isSignin === true || isSignin === "true") return navigate("/micredito");
    if (tokenSession) return navigate("/micredito");

    //Timer
    setInterval(() => {
      // Incrementar el temporizador en 1 segundo cada segundo
      setTimer((prevTimer) => prevTimer + 1);
    }, 1000);
  }, [navigate]);

  useEffect(() => {
    const previousBackground = document.body.style.background;

    document.body.style.background = "#000000";
    document.body.style.margin = "0";
    document.body.style.padding = "0";

    return () => {
      document.body.style.background = previousBackground;
      document.body.style.margin = "";
      document.body.style.padding = "";
    };
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (formRef.current) {
        formRef.current.scrollTo({
          top: 0,
          left: 0,
          behavior: "instant",
        });
      }
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    Promise.resolve(loadDraft()).catch(() => null);
  }, [loadDraft]);

  return (
    <Fragment>
      {viewalert ? (
        <>
          <SuccessAlert
            isOpen={isOpenSuccess}
            message={messsageAlert}
          ></SuccessAlert>
          <ErrorAlert isOpen={isOpenError} message={messsageAlert}></ErrorAlert>
        </>
      ) : (
        <></>
      )}

      {isDesktop && (
        <>
          <div
            class="z-20 flex flex-col md:flex-row items-center justify-center gap-2.5 text-[#ffffff]/70 pointer-events-none select-none tracking-widest uppercase font-light text-[10px] text-center my-6 md:my-0 md:fixed md:w-auto md:left-[-290px] md:top-[50%] md:-translate-y-1/2 md:-rotate-90 md:origin-center">
            <div class="flex flex-row items-center justify-center gap-4 mr-2">
              <div class="flex items-center md:border-r border-[#ffffff]/30 pr-4 shrink-0 capitalize">
                <img src="https://galilea.co/png/colombia-fintech.png" class="h-8 w-auto object-contain"
                  alt="colombia fintech" />
              </div>

              <div class="flex items-center md:border-r border-[#ffffff]/30 md:pr-4 shrink-0">
                <img src="https://galilea.co/png/sic.png" class="h-6 w-auto object-contain brightness-0 invert opacity-90"
                  alt="Superintendencia de Industria y Comercio" />
              </div>
            </div>
            <span
              class="normal-case text-[11px] leading-tight tracking-normal text-[#ffffff]/70 max-w-[280px] md:max-w-[340px] font-semibold2">
              Galilea es una marca de GRUPO EMPRESARIAL ANAV S.A.S GEAA <br class="hidden md:inline" />registrada en
              Colombia con NIT: 901.582.748-5
            </span>

          </div>
        </>
      )}

      <Login
        form={
          <form
            ref={formRef}
            className="
              w-full
              sm:px-10
              flex
              flex-col
              overflow-auto
              custom-scrollbar 
            "
            onKeyDown={handleKeyDown}
            style={{
              background:
                "linear-gradient(145deg, rgba(28,18,43,0.95) 0%, rgba(13,9,20,0.98) 100%)",
              width: isDesktop && "600px",
              height: getFormHeight(),
              borderRadius: "25px",
              border: "1px solid #FFFFFF1A",
              padding: "30px 40px 20px 40px",
              marginTop: !isDesktop && getFormMarginTop(),
              gap: getFormGap(),
            }}
          >
            <div
              className="flex justify-start w-full"
              style={{
                gap: isDesktop ? "130px" : "30px",
              }}
            >
              <button
                onClick={() => {
                  navigate("/");
                }}
                style={{ cursor: "pointer" }}
              >
                <ChevronLeft
                  className={`w-7 h-7 text-white`}
                  strokeWidth={2.5}
                />
              </button>
              <img
                className="h-12 w-48 cursor-pointer"
                src="/svg/imagotipo-galilea-02.svg"
                alt="Galilea"
                onClick={() => {
                  navigate("/");
                }}
              />
            </div>
            <div className="flex flex-col gap-5" style={{ marginTop: "5px" }}>
              <div>
                <h2
                  className="text-2xl md:text-2xl font-bold text-center text-white"
                  autoFocus
                >
                  <div>{"Da el primer paso para ser cliente"}</div>
                </h2>
                <p className="mt-1 text-sm leading-6 text-center text-grayP">
                  {
                    "Digita los datos tal como aparece en tu documento de identidad, recuerda que esta información será validada por tu seguridad."
                  }
                </p>
              </div>
              <div className="flex flex-col md:flex-row justify-center gap-5">
                <FilterableSelect
                  options={typeDocumentList.map((typeDocument) => ({
                    label: typeDocument.label,
                    value: typeDocument.value,
                  }))}
                  value={formSignup.typeDocument}
                  label={"Tipo de documento"}
                  onChange={(choice) => handleChangeSelect(choice)}
                  name="typeDocument"
                  placeholder="Seleccione una opción."
                  required
                  paddingRight="0px"
                  paddingLeft="0px"
                  error={errors.typeDocument}
                />

                <StepInput
                  name="document"
                  label={"Número de documento"}
                  onChange={handleChange}
                  value={formSignup.document}
                  required
                  placeholder="Ej. 1023456789"
                  autoFocus={true}
                  type="number"
                  inputMode="numeric"
                  minLength={0}
                  paddingRight="0px"
                  paddingLeft="0px"
                  error={errors.document}
                />
              </div>
              <div className="flex flex-col md:flex-row justify-center gap-5">
                <StepInput
                  name="email"
                  label={"Correo electrónico"}
                  onChange={handleChange}
                  value={formSignup.email}
                  required
                  placeholder="Ej. perez@gmail.com"
                  autoFocus={true}
                  type="email"
                  inputMode="email"
                  minLength={0}
                  paddingRight="0px"
                  paddingLeft="0px"
                  error={errors.email}
                  autoComplete="on"
                />
                <StepInput
                  iconLeft={
                    <div className="flex items-center gap-1">
                      <div className="w-5 h-5 bg-cover bg-no-repeat bg-center rounded-md m-1 bg-[url('/public/png/colombia-flag.png')]" />
                      <div
                        className="py-2 px-1 pl-0 text-lg"
                        style={{
                          color: formSignup.phone ? "#C9B8FF" : "#687099",
                        }}
                      >
                        +57
                      </div>
                    </div>
                  }
                  name="phone"
                  label={"Número de WhatsApp"}
                  onChange={handleChange}
                  value={formSignup.phone}
                  required
                  placeholder=" 3107143555"
                  autoFocus={true}
                  type="tel"
                  inputMode="tel"
                  minLength={0}
                  paddingRight="0px"
                  paddingLeft="0px"
                  maxLength={10}
                  error={errors.phone}
                  autoComplete="on"
                />
              </div>
            </div>

            <div className="items-center" style={{ marginTop: 0 }}>
              <div className="flex mt-1 items-start">
                <input
                  onChange={handleChange}
                  name="acceptAll"
                  type="checkbox"
                  className="h-5 w-5 mt-1 rounded-2xl cursor-pointer"
                  style={{
                    backgroundColor: "#FFFFFF0F",
                    border: "1px solid #FFFFFF33",
                  }}
                />
                <label className="ml-2 block text-white">
                  Autorizar todo
                </label>
              </div>
              <div
                className="flex flex-col rounded-2xl pl-6 pr-8 py-5 mt-3"
                style={{
                  backgroundColor: "rgba(124, 58, 237, 0.06)",
                  border: "1px solid rgba(124, 58, 237, 0.15)",
                  boxSizing: "border-box",
                }}
              >
                <div className="flex items-center">
                  <input
                    onChange={handleChange}
                    id="terms"
                    name="terms"
                    required
                    type="checkbox"
                    checked={formSignup.terms}
                    className="h-5 w-5 mt-1 rounded-2xl cursor-pointer"
                    style={{
                      backgroundColor: "#FFFFFF0F",
                      border: "1px solid #FFFFFF33",
                    }}
                  />
                  <label className="ml-2 block text-white">
                    Acepto los{" "}
                    <a href="/terminos" className="text-[#A78BFA]">
                      {" "}
                      Términos y condiciones{" "}
                    </a>
                  </label>
                </div>

                <div className="flex mt-2 items-center">
                  <input
                    onChange={handleChange}
                    id="policyData"
                    name="policyData"
                    required
                    type="checkbox"
                    checked={formSignup.policyData}
                    className="h-5 w-5 mt-1 rounded-2xl cursor-pointer"
                    style={{
                      backgroundColor: "#FFFFFF0F",
                      border: "1px solid #FFFFFF33",
                    }}
                  />
                  <label className="ml-2 block text-white">
                    Autorizo el{" "}
                    <a
                      href={variablesGlobales.policyData}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-[#A78BFA]"
                    >
                      {" "}
                      Tratamiento de datos personales{" "}
                    </a>
                  </label>
                </div>

                <div className="flex mt-2 items-start">
                  <input
                    onChange={handleChange}
                    id="policyAccessories"
                    name="policyAccessories"
                    required
                    type="checkbox"
                    checked={policyAccessories}
                    className="h-5 w-5 mt-1 rounded-2xl cursor-pointer"
                    style={{
                      backgroundColor: "#FFFFFF0F",
                      border: "1px solid #FFFFFF33",
                    }}
                  />
                  <label className="ml-2 block text-white">
                    Autorizo el{" "}
                    <a
                      href="/tratamiento-datos"
                      target="_blank"
                      className="text-[#A78BFA]"
                    >
                      {" "}
                      Tratamiento de las finalidades accesorias para el
                      tratamiento de mis datos{" "}
                    </a>
                  </label>
                </div>

                <div className="flex mt-2 items-start">
                  <input
                    onChange={handleChange}
                    id="channelsContact"
                    name="channelsContact"
                    type="checkbox"
                    checked={channelsContact}
                    className="h-5 w-5 mt-1 rounded-2xl cursor-pointer"
                    style={{
                      backgroundColor: "#FFFFFF0F",
                      border: "1px solid #FFFFFF33",
                    }}
                  />
                  <label className="ml-2 block text-white">
                    Autorizo ser contactado por los siguientes canales{" "}
                    <button
                      type="button"
                      onClick={() => setIsOpenChannels(!isOpenChannels)}
                      className="inline-flex items-center text-sm hover:text-purple-700 focus:outline-hidden"
                    >
                      <svg
                        className={`w-4 h-4 ml-1 transition-transform ${isOpenChannels ? "rotate-180" : ""
                          }`}
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M19 9l-7 7-7-7"
                        />
                      </svg>
                    </button>
                    <div className="w-full max-w-md">
                      <div className="relative">
                        {isOpenChannels && (
                          <div className="mt-2 bg-gray-50">
                            <div className="space-y-2 flex flex-col gap-1">
                              {channels.map((channel) => (
                                <label
                                  key={channel.id}
                                  className="flex items-center hover:bg-gray-100 cursor-pointer"
                                >
                                  <input
                                    type="checkbox"
                                    checked={selectedChannels.includes(
                                      channel.id,
                                    )}
                                    onChange={() =>
                                      handleCheckboxChange(channel.id)
                                    }
                                    className="h-5 w-5 mt-1 rounded-2xl cursor-pointer"
                                    style={{
                                      backgroundColor: "#FFFFFF0F",
                                      border: "1px solid #FFFFFF33",
                                    }}
                                  />
                                  <span className="ml-3 text-sm text-gray-700">
                                    {channel.label}
                                  </span>
                                </label>
                              ))}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </label>
                </div>
              </div>
              <div className="flex flex-col gap-1 mt-1">
                {errors.terms && (
                  <span
                    className="text-sm"
                    style={{ color: "#fc3e58", fontStyle: "italic" }}
                  >
                    {errors.terms}
                  </span>
                )}
                {errors.policyData && (
                  <span
                    className="text-sm"
                    style={{ color: "#fc3e58", fontStyle: "italic" }}
                  >
                    {errors.policyData}
                  </span>
                )}
              </div>
            </div>
            <RecaptchaView></RecaptchaView>
            {submitError && (
              <div className="text-center pb-2" role="alert">
                <span className="font-sm text-white">{submitError}</span>
                <button
                  type="button"
                  onClick={(e) => handleSubmit(e)}
                  disabled={isDisabled}
                  className="text-[#A78BFA] pl-2 underline"
                >
                  Reintentar
                </button>
              </div>
            )}
            <div className="block">
              <div className="text-center pb-2">
                <span className="font-sm text-white">
                  Te enviaremos un código a tu WhatsApp para verificar tu cuenta
                </span>
              </div>

              <div className="w-full">
                <NextButton
                  label={"Empezar"}
                  isLastStep={false}
                  showIconNext={false}
                  onNext={(e) => {
                    handleSubmit(e);
                  }}
                  isLoading={isLoading}
                  // disabled={disableBtn}
                  disabled={isDisabled}
                  isUnicButtom={true}
                />
              </div>
            </div>
            <div className="flex justify-center" style={{ marginTop: "10px" }}>
              <span className="text-white">
                ¿Ya eres cliente?
                <a href="/ingresar" className="text-[#A78BFA] pl-2">
                  Ingresa a tu cuenta
                </a>
              </span>
            </div>
          </form>
        }
      />
    </Fragment>
  );
}
